module.exports = __webpack_public_path__ + "static/media/search-recognitions-filter.c6fb68b3.svg";